<template>
    <div class="text-center py-10">
        <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
    </div>
</template>
<script setup>
import { VxIconLoading } from '@voxie/frontend-components';
</script>
